import React, { Fragment, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetCustomerList2,
  SetCustomerList2,
} from "../../store/customerAtom";
import { customerService } from "../../services/customer.service";
import { debounce } from "lodash";
import LogicContext from "../../Context/LogicContext";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

interface ComponentProps {
  default: any,
  onCustomerSelected: (customer: any) => void;
  // editUserAccessLevel: (id: string, accessLevel: string) => void;
}

const CustomerSearchSelect:  React.FC<ComponentProps> = (props) => {
  const {onCustomerSelected} = props;

  const logicContext = useContext(LogicContext);
  const [searchResult, setSearchResult] = useState([]);
  const navigate = useNavigate();
  const customerListBackup = GetCustomerList2();
  const setCustomerAtomList = SetCustomerList2();
  const [textInput, setTextInput] = useState("");



  useEffect(() => {
    if (customerListBackup.customer_info?.length < 1) {
      getCustomerListData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerListBackup?.customer_count_info?.length]);

  const getCustomerListData = async () => {
    let isMounted = true;
    const response = await customerService.getCustomerListNoCache(0, 50);
    if (isMounted && response.data?.customer_info?.length) {
      setCustomerAtomList(response?.data);
    }
    return () => {
      isMounted = false;
    };
  };


  const debouncedSearch = React.useRef(
    debounce(async (search: any) => {
      processSearch(search);
    }, 700)
  ).current;

  function processSearch(search: string) {
    if (search?.length > 2) {
      customerService.getCustomerListSearch(search).then((res) => {
        if (res?.data?.length > 0) {
          return setSearchResult(res?.data);
        } else {
          logicContext.showToast(
            "No available record for your search query! ",
            ""
          );
          return setSearchResult([]);
        }
      });
    } else {
      setSearchResult([]);
    }
  }

  return (
    <>
      <Combobox>
        <div className="relative">
          <div className="relative border-[1px] border-gray-200 rounded-md">
            <Combobox.Input
              className="w-full z-40 border-none py-2 pl-10 text-sm leading-5 text-gray-700  h-[8vh] bg-white rounded-md overflow-hidden ring-0 focus:ring-1 focus:ring-[#1976D2]"
              // displayValue={(person) => person.name}
              placeholder="Search customer....."
              onChange={(event) => debouncedSearch(event.target.value)}
              // onChange={(event) => setTextInput(event.target.value)}
            />
            <Combobox.Button className="absolute top-2 left-2.5 z-50">
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setTextInput("")}
          >
            <Combobox.Options className="z-999 absolute mt-1  w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
              {searchResult?.length === 0 && textInput !== "" ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                searchResult.map((customer: any, i: number) => (
                  <Combobox.Option key={i}   onClick={() => onCustomerSelected(customer)}
                    className={({ active }) =>
                      `relative z-999 cursor-pointer select-none py-2 pl-10 pr-4 ${
                        active ? "bg-gray-100 text-white" : "text-gray-700"  }`}
                    value={customer}>
                    {({ selected, active }) => (
                      <>
                        <span className={` ${  selected ? "font-medium" : "font-normal" }`} >
                          {customer.Name} | {customer?.Email_Address} | {customer?.Mobile}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute z-999 inset-y-0 left-0 flex items-center pl-3 ${
                              active ? "text-white" : "text-gray-700" }`} >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </>
  );
}

export default CustomerSearchSelect;
